<div class="recipe-editor-list-item-container" [class.selected]="editorSvc.selectedWorkflow.id === recipe.id">
    <div class="list-item-picto-container">
        <img src="/assets/pictos/workflows/{{recipe.id}}.svg" alt={{recipe.id}}>  
    </div>
    <div class="list-item-title">{{recipe.title_en}}</div>
</div>
